import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { YouSpinner } from '../YouSpinner/YouSpinner';
import { COLOR_TEXT_TERTIARY } from '../colors/colors';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 16px;
  animation: ${fadeIn} 300ms ease-in;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Text = styled.span`
  font-size: 14px;
  color: ${COLOR_TEXT_TERTIARY};
`;

export const YouLoading = ({ text = '' }) => {
  return (
    <Container>
      <YouSpinner size={40} thickness="3px" />
      {text && <Text>{text}</Text>}
    </Container>
  );
};

YouLoading.propTypes = {
  text: PropTypes.string,
};
